<template>
  <div class="container">
    <div class="title">
      选择材料类别
    </div>
    <card>
      <div v-for="(item,index) in list" :key="index" @click="$router.push({path:'/guide/uploadScore',query:{type:index,guideId:guideId}})">
         <listItem :label="item" :color="'#999999'">
        <right></right>
      </listItem>
      <rline></rline>
      </div>

    </card>

  </div>
</template>
<script>
    import card from '../travelAgency/components/card'
    import right from './components/right'
    import listItem from './components/list-item'
    import rline from '../travelAgency/components/line'
    export default {
        components: {
            card,
            listItem,
            right,
            rline
        },

        data () {
            return {
                list: ['表彰奖励或入选专家库、人才库', '参加公益活动', '行政处罚及其他违规行为', '其他不规范执业行为'],
                guideId: ''
            }
        },

        computed: {},

        watch: {},

        methods: {},

        mounted () {
            this.guideId = this.$route.query.guideId
        },

        created () {}

    }
</script>
<style scoped lang="less">
  .container {
    padding: 12px 16px;
    height: 100vh;
    background: @base-bgcolor;

    .title {
      margin-top: 8px;
      margin-bottom: 12px;
      font-size: 16px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
    }

  }
</style>
